import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, vShow as _vShow, vModelText as _vModelText, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-xxl-8 col-lg-7" }
const _hoisted_7 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_8 = { class: "card-body py-4 px-0" }
const _hoisted_9 = { class: "default-table-area style-two all-projects" }
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "table align-middle" }
const _hoisted_12 = { class: "text-body fw-bold" }
const _hoisted_13 = { class: "badge bg-secondary" }
const _hoisted_14 = { class: "text-secondary" }
const _hoisted_15 = { class: "badge bg-primary-subtle text-primary fs-12 fw-medium" }
const _hoisted_16 = {
  key: 0,
  class: "d-block text-muted",
  style: {"font-size":"11px"}
}
const _hoisted_17 = { class: "text-dark fw-bold" }
const _hoisted_18 = { class: "card bg-white border-0 rounded-3 mb-4 shadow-sm" }
const _hoisted_19 = { class: "card-body p-4" }
const _hoisted_20 = {
  key: 0,
  class: "mb-4 pb-3 border-bottom"
}
const _hoisted_21 = { class: "fs-14 fw-semibold mb-3" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "card border border-light shadow-sm h-100 rounded-3 p-3" }
const _hoisted_24 = { class: "d-flex align-items-center mb-2" }
const _hoisted_25 = { class: "material-symbols-outlined text-primary fs-24 me-2" }
const _hoisted_26 = { class: "mb-0 fs-14 fw-semibold text-dark" }
const _hoisted_27 = {
  class: "text-secondary fs-13 mb-0 text-truncate-3",
  style: {"max-height":"54px","overflow":"hidden","text-overflow":"ellipsis","display":"-webkit-box","-webkit-line-clamp":"3","-webkit-box-orient":"vertical"}
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "list-group list-group-flush mb-0" }
const _hoisted_30 = { class: "list-group-item px-0 pb-2 pt-0 d-flex justify-content-between" }
const _hoisted_31 = { class: "fw-medium text-dark" }
const _hoisted_32 = { class: "list-group-item px-0 py-2 d-flex justify-content-between" }
const _hoisted_33 = { class: "fw-medium text-dark" }
const _hoisted_34 = { class: "list-group-item px-0 py-2 d-flex justify-content-between" }
const _hoisted_35 = { class: "fw-medium text-dark" }
const _hoisted_36 = { class: "list-group-item px-0 py-2 d-flex justify-content-between" }
const _hoisted_37 = { class: "fw-medium text-dark" }
const _hoisted_38 = {
  key: 0,
  class: "list-group-item px-0 py-2 d-flex justify-content-between"
}
const _hoisted_39 = { class: "fw-medium text-dark" }
const _hoisted_40 = {
  key: 1,
  class: "list-group-item px-0 py-2 d-flex justify-content-between"
}
const _hoisted_41 = { class: "fw-medium text-dark" }
const _hoisted_42 = {
  key: 0,
  class: "badge bg-warning-subtle text-warning-emphasis ms-2"
}
const _hoisted_43 = { key: 2 }
const _hoisted_44 = { class: "list-group list-group-flush mb-0" }
const _hoisted_45 = {
  key: 0,
  class: "list-group-item px-0 pb-2 pt-0 d-flex justify-content-between"
}
const _hoisted_46 = { class: "fw-medium text-dark" }
const _hoisted_47 = {
  key: 1,
  class: "list-group-item px-0 py-2 d-flex justify-content-between"
}
const _hoisted_48 = { class: "fw-medium text-dark" }
const _hoisted_49 = {
  key: 0,
  class: "badge bg-warning-subtle text-warning-emphasis ms-2"
}
const _hoisted_50 = { key: 3 }
const _hoisted_51 = { class: "list-group list-group-flush mb-0" }
const _hoisted_52 = { class: "list-group-item px-0 pb-2 pt-0 d-flex justify-content-between" }
const _hoisted_53 = { class: "fw-medium text-dark" }
const _hoisted_54 = { class: "list-group-item px-0 py-2 d-flex justify-content-between" }
const _hoisted_55 = { class: "fw-medium text-dark" }
const _hoisted_56 = { class: "list-group-item px-0 py-2" }
const _hoisted_57 = { class: "p-3 bg-light rounded" }
const _hoisted_58 = {
  key: 0,
  class: "list-group-item px-0 py-2 d-flex justify-content-between"
}
const _hoisted_59 = { class: "fw-medium text-dark" }
const _hoisted_60 = {
  key: 1,
  class: "list-group-item px-0 py-2 d-flex justify-content-between"
}
const _hoisted_61 = { class: "fw-medium text-dark" }
const _hoisted_62 = {
  key: 0,
  class: "badge bg-warning-subtle text-warning-emphasis ms-2"
}
const _hoisted_63 = { key: 4 }
const _hoisted_64 = { class: "list-group list-group-flush mb-0" }
const _hoisted_65 = { class: "list-group-item px-0 pb-2 pt-0 d-flex justify-content-between" }
const _hoisted_66 = { class: "fw-medium text-dark" }
const _hoisted_67 = { class: "list-group-item px-0 py-2" }
const _hoisted_68 = { class: "p-3 bg-light rounded" }
const _hoisted_69 = {
  key: 0,
  class: "list-group-item px-0 py-2 d-flex justify-content-between"
}
const _hoisted_70 = { class: "fw-medium text-dark" }
const _hoisted_71 = {
  key: 1,
  class: "list-group-item px-0 py-2 d-flex justify-content-between"
}
const _hoisted_72 = { class: "fw-medium text-dark" }
const _hoisted_73 = {
  key: 0,
  class: "badge bg-warning-subtle text-warning-emphasis ms-2"
}
const _hoisted_74 = { key: 5 }
const _hoisted_75 = { class: "list-group list-group-flush mb-0" }
const _hoisted_76 = { class: "list-group-item px-0 pb-2 pt-0 d-flex justify-content-between" }
const _hoisted_77 = { class: "fw-medium text-dark" }
const _hoisted_78 = { class: "list-group-item px-0 py-2 d-flex justify-content-between" }
const _hoisted_79 = { class: "fw-medium text-dark" }
const _hoisted_80 = { class: "list-group-item px-0 py-2 d-flex justify-content-between" }
const _hoisted_81 = { class: "fw-medium text-dark" }
const _hoisted_82 = {
  key: 0,
  class: "list-group-item px-0 py-2 d-flex justify-content-between"
}
const _hoisted_83 = { class: "fw-medium text-dark" }
const _hoisted_84 = {
  key: 1,
  class: "list-group-item px-0 py-2 d-flex justify-content-between"
}
const _hoisted_85 = { class: "fw-medium text-dark" }
const _hoisted_86 = {
  key: 0,
  class: "badge bg-warning-subtle text-warning-emphasis ms-2"
}
const _hoisted_87 = { key: 6 }
const _hoisted_88 = { class: "list-group list-group-flush mb-0" }
const _hoisted_89 = { class: "list-group-item px-0 pb-2 pt-0 d-flex justify-content-between" }
const _hoisted_90 = { class: "fw-medium text-dark" }
const _hoisted_91 = { class: "list-group-item px-0 py-2 d-flex justify-content-between" }
const _hoisted_92 = { class: "fw-medium text-dark" }
const _hoisted_93 = {
  key: 0,
  class: "list-group-item px-0 py-2 d-flex justify-content-between"
}
const _hoisted_94 = { class: "fw-medium text-dark" }
const _hoisted_95 = {
  key: 1,
  class: "list-group-item px-0 py-2 d-flex justify-content-between"
}
const _hoisted_96 = { class: "fw-medium text-dark" }
const _hoisted_97 = {
  key: 0,
  class: "badge bg-warning-subtle text-warning-emphasis ms-2"
}
const _hoisted_98 = { key: 7 }
const _hoisted_99 = { class: "list-group list-group-flush mb-4" }
const _hoisted_100 = { class: "list-group-item px-0 pb-2 pt-0 d-flex justify-content-between" }
const _hoisted_101 = { class: "fw-medium text-dark" }
const _hoisted_102 = { class: "list-group-item px-0 py-2 d-flex justify-content-between" }
const _hoisted_103 = { class: "fw-medium text-dark" }
const _hoisted_104 = { class: "list-group-item px-0 py-2 d-flex justify-content-between" }
const _hoisted_105 = { class: "fw-medium text-dark" }
const _hoisted_106 = { class: "list-group-item px-0 py-2 d-flex justify-content-between" }
const _hoisted_107 = { class: "fw-medium text-dark" }
const _hoisted_108 = { class: "list-group list-group-flush mb-4" }
const _hoisted_109 = { class: "list-group-item px-0 pb-2 pt-0 d-flex justify-content-between" }
const _hoisted_110 = { class: "fw-medium text-dark" }
const _hoisted_111 = { class: "list-group-item px-0 py-2" }
const _hoisted_112 = { class: "p-3 bg-light rounded" }
const _hoisted_113 = { class: "list-group list-group-flush mb-4" }
const _hoisted_114 = { class: "list-group-item px-0 py-2" }
const _hoisted_115 = { class: "p-3 bg-light rounded" }
const _hoisted_116 = { class: "list-group list-group-flush mb-0" }
const _hoisted_117 = { class: "list-group-item px-0 pb-2 pt-0 d-flex justify-content-between" }
const _hoisted_118 = { class: "fw-medium text-dark" }
const _hoisted_119 = { class: "list-group-item px-0 py-2 d-flex justify-content-between" }
const _hoisted_120 = { class: "fw-medium text-dark" }
const _hoisted_121 = {
  key: 0,
  class: "list-group-item px-0 py-2 d-flex justify-content-between"
}
const _hoisted_122 = { class: "fw-medium text-dark" }
const _hoisted_123 = {
  key: 1,
  class: "list-group-item px-0 py-2 d-flex justify-content-between"
}
const _hoisted_124 = { class: "fw-medium text-dark" }
const _hoisted_125 = {
  key: 0,
  class: "badge bg-warning-subtle text-warning-emphasis ms-2"
}
const _hoisted_126 = {
  key: 8,
  class: "mt-4 pt-3 border-top"
}
const _hoisted_127 = { class: "list-group list-group-flush mb-0" }
const _hoisted_128 = { class: "list-group-item px-0 py-2 d-flex justify-content-between border-0" }
const _hoisted_129 = { class: "fw-medium text-dark" }
const _hoisted_130 = { class: "text-muted" }
const _hoisted_131 = { class: "card bg-white border-0 rounded-3 mb-4 shadow-sm" }
const _hoisted_132 = { class: "card-body p-4" }
const _hoisted_133 = { class: "row g-3 align-items-center" }
const _hoisted_134 = { class: "col-md-6" }
const _hoisted_135 = { class: "input-group" }
const _hoisted_136 = ["disabled"]
const _hoisted_137 = ["value"]
const _hoisted_138 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_139 = { class: "badge bg-primary-subtle text-primary fs-11 me-1" }
const _hoisted_140 = { class: "badge bg-info-subtle text-info fs-11 me-1" }
const _hoisted_141 = {
  key: 0,
  class: "badge bg-light text-muted border fs-11"
}
const _hoisted_142 = {
  key: 1,
  class: "badge bg-light text-muted border fs-11 ms-1"
}
const _hoisted_143 = { class: "col-md-6" }
const _hoisted_144 = { class: "input-group" }
const _hoisted_145 = { class: "mt-2 fs-12 text-muted" }
const _hoisted_146 = {
  key: 0,
  class: "card border-0 rounded-3 mb-3 bg-white p-3 shadow-sm"
}
const _hoisted_147 = { class: "d-flex align-items-center justify-content-between flex-wrap gap-2" }
const _hoisted_148 = { class: "fw-bold fs-14 text-dark d-block" }
const _hoisted_149 = { class: "text-muted fs-12" }
const _hoisted_150 = { class: "btn-group" }
const _hoisted_151 = ["onClick"]
const _hoisted_152 = {
  key: 4,
  class: "card bg-white border-0 rounded-3 mb-4"
}
const _hoisted_153 = { class: "card-body p-4" }
const _hoisted_154 = { class: "d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2" }
const _hoisted_155 = {
  key: 0,
  class: "d-flex flex-wrap gap-1"
}
const _hoisted_156 = ["onClick"]
const _hoisted_157 = ["src"]
const _hoisted_158 = {
  key: 1,
  style: {"height":"600px","border":"1px solid #eee","border-radius":"8px","overflow":"hidden"}
}
const _hoisted_159 = { class: "col-xxl-4 col-lg-5" }
const _hoisted_160 = { class: "card bg-white border-0 rounded-3 mb-4 rounded-3" }
const _hoisted_161 = { class: "card-body p-4" }
const _hoisted_162 = { class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3" }
const _hoisted_163 = ["href", "target", "download"]
const _hoisted_164 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3"
}
const _hoisted_165 = ["href", "target", "download"]
const _hoisted_166 = {
  key: 1,
  class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3"
}
const _hoisted_167 = { class: "d-flex align-items-center" }
const _hoisted_168 = { class: "flex-grow-1 ms-3" }
const _hoisted_169 = { class: "fs-14 fw-bold text-dark" }
const _hoisted_170 = { class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3" }
const _hoisted_171 = ["href", "target", "download"]
const _hoisted_172 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3"
}
const _hoisted_173 = ["href", "target", "download"]
const _hoisted_174 = {
  key: 1,
  class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3"
}
const _hoisted_175 = { class: "d-flex align-items-center" }
const _hoisted_176 = { class: "flex-grow-1 ms-3" }
const _hoisted_177 = { class: "fs-14 fw-bold text-dark" }
const _hoisted_178 = { class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3" }
const _hoisted_179 = ["href", "target", "download"]
const _hoisted_180 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3"
}
const _hoisted_181 = ["href", "target", "download"]
const _hoisted_182 = { class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3" }
const _hoisted_183 = ["href", "target", "download"]
const _hoisted_184 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3"
}
const _hoisted_185 = ["href", "target", "download"]
const _hoisted_186 = {
  key: 1,
  class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3"
}
const _hoisted_187 = ["href", "target", "download"]
const _hoisted_188 = { class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3" }
const _hoisted_189 = ["href", "target", "download"]
const _hoisted_190 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3"
}
const _hoisted_191 = ["href", "target", "download"]
const _hoisted_192 = { class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3" }
const _hoisted_193 = ["href", "target", "download"]
const _hoisted_194 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3"
}
const _hoisted_195 = ["href", "target", "download"]
const _hoisted_196 = { class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3" }
const _hoisted_197 = ["href", "target", "download"]
const _hoisted_198 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3"
}
const _hoisted_199 = ["href", "target", "download"]
const _hoisted_200 = {
  key: 1,
  class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3"
}
const _hoisted_201 = { class: "d-flex align-items-center" }
const _hoisted_202 = { class: "flex-grow-1 ms-3" }
const _hoisted_203 = { class: "fs-14 fw-bold text-dark" }
const _hoisted_204 = {
  key: 2,
  class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3"
}
const _hoisted_205 = ["href", "target", "download"]
const _hoisted_206 = {
  key: 3,
  class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3"
}
const _hoisted_207 = ["href", "target", "download"]
const _hoisted_208 = {
  key: 4,
  class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3"
}
const _hoisted_209 = ["href", "target", "download"]
const _hoisted_210 = {
  key: 5,
  class: "d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3"
}
const _hoisted_211 = ["href", "target", "download"]
const _hoisted_212 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_213 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_214 = { class: "form-label fs-13" }
const _hoisted_215 = ["placeholder"]
const _hoisted_216 = { class: "mb-3" }
const _hoisted_217 = ["disabled"]
const _hoisted_218 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_SimilarityProtocolForm = _resolveComponent("SimilarityProtocolForm")!
  const _component_GrammarlyProtocolForm = _resolveComponent("GrammarlyProtocolForm")!
  const _component_AiDetectorProtocolForm = _resolveComponent("AiDetectorProtocolForm")!
  const _component_OrderDeliverablesAndQc = _resolveComponent("OrderDeliverablesAndQc")!
  const _component_vue_office_docx = _resolveComponent("vue-office-docx")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: "Order Details",
      subTitle: "Transactions"
    }),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[12] || (_cache[12] = [
          _createElementVNode("div", {
            class: "spinner-border text-primary",
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ])))
      : (!_ctx.order)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Order not found. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("table", _hoisted_11, [
                          _cache[13] || (_cache[13] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", { scope: "col" }, "Order ID"),
                              _createElementVNode("th", { scope: "col" }, "Customer"),
                              _createElementVNode("th", { scope: "col" }, "Service Type"),
                              _createElementVNode("th", { scope: "col" }, "Service Name"),
                              _createElementVNode("th", { scope: "col" }, "Klasifikasi Dokumen"),
                              _createElementVNode("th", { scope: "col" }, "Total Price"),
                              _createElementVNode("th", { scope: "col" }, "Status")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_12, "#" + _toDisplayString(_ctx.order.order_id), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.order.customer?.name || _ctx.order.customer?.phone_number || '-'), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.order.service_type), 1)
                              ]),
                              _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.order.service?.service_name || _ctx.order.package?.package_name || '-'), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.order.service_classification || 'Artikel Jurnal'), 1),
                                (_ctx.order.similarity_profile?.profile_name)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_16, _toDisplayString(_ctx.order.similarity_profile.profile_name), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", _hoisted_17, "Rp " + _toDisplayString(Number(_ctx.order.total_price).toLocaleString('id-ID')), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["badge p-2 fs-12 fw-normal", _ctx.statusClass(_ctx.order.order_status)])
                                }, _toDisplayString(_ctx.order.order_status), 3)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _cache[56] || (_cache[56] = _createElementVNode("div", { class: "d-flex align-items-center gap-2 mb-4 pb-2 border-bottom" }, [
                      _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-22" }, "assignment"),
                      _createElementVNode("h4", { class: "fs-15 mb-0 fw-bold text-dark" }, "Rincian Kebutuhan Layanan")
                    ], -1)),
                    (_ctx.order.package)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("h5", _hoisted_21, "Services Included in Package (" + _toDisplayString(_ctx.order.package.package_name) + ")", 1),
                          _createElementVNode("div", _hoisted_22, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.package.services, (svc) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "col-md-6 col-lg-4 mb-3",
                                key: svc.service_id
                              }, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("span", _hoisted_25, _toDisplayString(svc.icon || 'settings'), 1),
                                    _createElementVNode("h6", _hoisted_26, _toDisplayString(svc.service_name), 1)
                                  ]),
                                  _createElementVNode("p", _hoisted_27, _toDisplayString(svc.description), 1)
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.order.service_type === 'PLAGIARISM' && _ctx.order.plagiarism_detail)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createElementVNode("ul", _hoisted_29, [
                            _createElementVNode("li", _hoisted_30, [
                              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-secondary" }, "Language", -1)),
                              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.order.plagiarism_detail.language === 'id' ? 'Indonesian' : 'English'), 1)
                            ]),
                            _createElementVNode("li", _hoisted_32, [
                              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-secondary" }, "Exclude Quotes", -1)),
                              _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.order.plagiarism_detail.exclude_quotes ? 'Yes' : 'No'), 1)
                            ]),
                            _createElementVNode("li", _hoisted_34, [
                              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-secondary" }, "Exclude Bibliography", -1)),
                              _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.order.plagiarism_detail.exclude_bibliography ? 'Yes' : 'No'), 1)
                            ]),
                            _createElementVNode("li", _hoisted_36, [
                              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-secondary" }, "Exclude Match", -1)),
                              _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.order.plagiarism_detail.exclude_match ? 'Yes' : 'No'), 1)
                            ]),
                            (_ctx.order.plagiarism_detail.page_count)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                                  _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-secondary" }, "Page Count", -1)),
                                  _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.order.plagiarism_detail.page_count), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.order.plagiarism_detail.price_tier)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_40, [
                                  _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-secondary" }, "Price Tier", -1)),
                                  _createElementVNode("span", _hoisted_41, [
                                    _createTextVNode(_toDisplayString(_ctx.order.plagiarism_detail.price_tier.label) + " ", 1),
                                    (_ctx.order.plagiarism_detail.price_tier.deadline)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.order.plagiarism_detail.price_tier.deadline), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : (_ctx.order.service_type === 'AI_CHECK' && _ctx.order.ai_check_detail)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _createElementVNode("ul", _hoisted_44, [
                              (_ctx.order.ai_check_detail.page_count)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
                                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-secondary" }, "Page Count", -1)),
                                    _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.order.ai_check_detail.page_count), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.order.ai_check_detail.price_tier)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_47, [
                                    _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-secondary" }, "Price Tier", -1)),
                                    _createElementVNode("span", _hoisted_48, [
                                      _createTextVNode(_toDisplayString(_ctx.order.ai_check_detail.price_tier.label) + " ", 1),
                                      (_ctx.order.ai_check_detail.price_tier.deadline)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_ctx.order.ai_check_detail.price_tier.deadline), 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : (_ctx.order.service_type === 'PARAPHRASE' && _ctx.order.paraphrase_detail)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                              _createElementVNode("ul", _hoisted_51, [
                                _createElementVNode("li", _hoisted_52, [
                                  _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-secondary" }, "Language", -1)),
                                  _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.order.paraphrase_detail.language === 'id' ? 'Indonesian' : 'English'), 1)
                                ]),
                                _createElementVNode("li", _hoisted_54, [
                                  _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-secondary" }, "Paraphrase Level", -1)),
                                  _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.order.paraphrase_detail.paraphrase_level), 1)
                                ]),
                                _createElementVNode("li", _hoisted_56, [
                                  _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-secondary d-block mb-1" }, "Special Instructions", -1)),
                                  _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.order.paraphrase_detail.special_instructions || 'None provided.'), 1)
                                ]),
                                (_ctx.order.paraphrase_detail.page_count)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_58, [
                                      _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-secondary" }, "Page Count", -1)),
                                      _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.order.paraphrase_detail.page_count), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.order.paraphrase_detail.price_tier)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_60, [
                                      _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text-secondary" }, "Price Tier", -1)),
                                      _createElementVNode("span", _hoisted_61, [
                                        _createTextVNode(_toDisplayString(_ctx.order.paraphrase_detail.price_tier.label) + " ", 1),
                                        (_ctx.order.paraphrase_detail.price_tier.deadline)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.order.paraphrase_detail.price_tier.deadline), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : (_ctx.order.service_type === 'DOC_FIX' && _ctx.order.document_fix_detail)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                _createElementVNode("ul", _hoisted_64, [
                                  _createElementVNode("li", _hoisted_65, [
                                    _cache[27] || (_cache[27] = _createElementVNode("span", { class: "text-secondary" }, "Language", -1)),
                                    _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.order.document_fix_detail.language === 'id' ? 'Indonesian' : 'English'), 1)
                                  ]),
                                  _createElementVNode("li", _hoisted_67, [
                                    _cache[28] || (_cache[28] = _createElementVNode("span", { class: "text-secondary d-block mb-1" }, "Fix Notes", -1)),
                                    _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.order.document_fix_detail.fix_notes || 'None provided.'), 1)
                                  ]),
                                  (_ctx.order.document_fix_detail.page_count)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_69, [
                                        _cache[29] || (_cache[29] = _createElementVNode("span", { class: "text-secondary" }, "Page Count", -1)),
                                        _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.order.document_fix_detail.page_count), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.order.document_fix_detail.price_tier)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_71, [
                                        _cache[30] || (_cache[30] = _createElementVNode("span", { class: "text-secondary" }, "Price Tier", -1)),
                                        _createElementVNode("span", _hoisted_72, [
                                          _createTextVNode(_toDisplayString(_ctx.order.document_fix_detail.price_tier.label) + " ", 1),
                                          (_ctx.order.document_fix_detail.price_tier.deadline)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(_ctx.order.document_fix_detail.price_tier.deadline), 1))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : (_ctx.order.service_type === 'JOURNAL' && _ctx.order.journal_detail)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                  _createElementVNode("ul", _hoisted_75, [
                                    _createElementVNode("li", _hoisted_76, [
                                      _cache[31] || (_cache[31] = _createElementVNode("span", { class: "text-secondary" }, "Target Index", -1)),
                                      _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.order.journal_detail.target_index), 1)
                                    ]),
                                    _createElementVNode("li", _hoisted_78, [
                                      _cache[32] || (_cache[32] = _createElementVNode("span", { class: "text-secondary" }, "Field of Study", -1)),
                                      _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.order.journal_detail.field_of_study), 1)
                                    ]),
                                    _createElementVNode("li", _hoisted_80, [
                                      _cache[33] || (_cache[33] = _createElementVNode("span", { class: "text-secondary" }, "Language", -1)),
                                      _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.order.journal_detail.language === 'id' ? 'Indonesian' : 'English'), 1)
                                    ]),
                                    (_ctx.order.journal_detail.page_count)
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_82, [
                                          _cache[34] || (_cache[34] = _createElementVNode("span", { class: "text-secondary" }, "Page Count", -1)),
                                          _createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.order.journal_detail.page_count), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.order.journal_detail.price_tier)
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_84, [
                                          _cache[35] || (_cache[35] = _createElementVNode("span", { class: "text-secondary" }, "Price Tier", -1)),
                                          _createElementVNode("span", _hoisted_85, [
                                            _createTextVNode(_toDisplayString(_ctx.order.journal_detail.price_tier.label) + " ", 1),
                                            (_ctx.order.journal_detail.price_tier.deadline)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_86, _toDisplayString(_ctx.order.journal_detail.price_tier.deadline), 1))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : (_ctx.order.service_type === 'TRANSLATE' && _ctx.order.translate_detail)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                    _createElementVNode("ul", _hoisted_88, [
                                      _createElementVNode("li", _hoisted_89, [
                                        _cache[36] || (_cache[36] = _createElementVNode("span", { class: "text-secondary" }, "Language", -1)),
                                        _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.order.translate_detail.language === 'id to en' ? 'Indonesia ke Inggris' : (_ctx.order.translate_detail.language === 'en to id' ? 'Inggris ke Indonesia' : _ctx.order.translate_detail.language)), 1)
                                      ]),
                                      _createElementVNode("li", _hoisted_91, [
                                        _cache[37] || (_cache[37] = _createElementVNode("span", { class: "text-secondary" }, "Field of Study", -1)),
                                        _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.order.translate_detail.field_of_study), 1)
                                      ]),
                                      (_ctx.order.translate_detail.page_count)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_93, [
                                            _cache[38] || (_cache[38] = _createElementVNode("span", { class: "text-secondary" }, "Page Count", -1)),
                                            _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.order.translate_detail.page_count) + " halaman", 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.order.translate_detail.price_tier)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_95, [
                                            _cache[39] || (_cache[39] = _createElementVNode("span", { class: "text-secondary" }, "Price Tier", -1)),
                                            _createElementVNode("span", _hoisted_96, [
                                              _createTextVNode(_toDisplayString(_ctx.order.translate_detail.price_tier.label) + " ", 1),
                                              (_ctx.order.translate_detail.price_tier.deadline)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_97, _toDisplayString(_ctx.order.translate_detail.price_tier.deadline), 1))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : (_ctx.order.service_type === 'ALL' && _ctx.order.all_detail)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                      _cache[51] || (_cache[51] = _createElementVNode("h5", { class: "fs-14 fw-semibold mb-3" }, "Plagiarism Settings", -1)),
                                      _createElementVNode("ul", _hoisted_99, [
                                        _createElementVNode("li", _hoisted_100, [
                                          _cache[40] || (_cache[40] = _createElementVNode("span", { class: "text-secondary" }, "Language", -1)),
                                          _createElementVNode("span", _hoisted_101, _toDisplayString(_ctx.order.all_detail.language === 'id' ? 'Indonesian' : 'English'), 1)
                                        ]),
                                        _createElementVNode("li", _hoisted_102, [
                                          _cache[41] || (_cache[41] = _createElementVNode("span", { class: "text-secondary" }, "Exclude Quotes", -1)),
                                          _createElementVNode("span", _hoisted_103, _toDisplayString(_ctx.order.all_detail.exclude_quotes ? 'Yes' : 'No'), 1)
                                        ]),
                                        _createElementVNode("li", _hoisted_104, [
                                          _cache[42] || (_cache[42] = _createElementVNode("span", { class: "text-secondary" }, "Exclude Bibliography", -1)),
                                          _createElementVNode("span", _hoisted_105, _toDisplayString(_ctx.order.all_detail.exclude_bibliography ? 'Yes' : 'No'), 1)
                                        ]),
                                        _createElementVNode("li", _hoisted_106, [
                                          _cache[43] || (_cache[43] = _createElementVNode("span", { class: "text-secondary" }, "Exclude Match", -1)),
                                          _createElementVNode("span", _hoisted_107, _toDisplayString(_ctx.order.all_detail.exclude_match ? 'Yes' : 'No'), 1)
                                        ])
                                      ]),
                                      _cache[52] || (_cache[52] = _createElementVNode("h5", { class: "fs-14 fw-semibold mb-3" }, "Paraphrase Settings", -1)),
                                      _createElementVNode("ul", _hoisted_108, [
                                        _createElementVNode("li", _hoisted_109, [
                                          _cache[44] || (_cache[44] = _createElementVNode("span", { class: "text-secondary" }, "Paraphrase Level", -1)),
                                          _createElementVNode("span", _hoisted_110, _toDisplayString(_ctx.order.all_detail.paraphrase_level), 1)
                                        ]),
                                        _createElementVNode("li", _hoisted_111, [
                                          _cache[45] || (_cache[45] = _createElementVNode("span", { class: "text-secondary d-block mb-1" }, "Special Instructions", -1)),
                                          _createElementVNode("div", _hoisted_112, _toDisplayString(_ctx.order.all_detail.special_instructions || 'None provided.'), 1)
                                        ])
                                      ]),
                                      _cache[53] || (_cache[53] = _createElementVNode("h5", { class: "fs-14 fw-semibold mb-3" }, "Document Fix Settings", -1)),
                                      _createElementVNode("ul", _hoisted_113, [
                                        _createElementVNode("li", _hoisted_114, [
                                          _cache[46] || (_cache[46] = _createElementVNode("span", { class: "text-secondary d-block mb-1" }, "Fix Notes", -1)),
                                          _createElementVNode("div", _hoisted_115, _toDisplayString(_ctx.order.all_detail.fix_notes || 'None provided.'), 1)
                                        ])
                                      ]),
                                      _cache[54] || (_cache[54] = _createElementVNode("h5", { class: "fs-14 fw-semibold mb-3" }, "Journal Settings", -1)),
                                      _createElementVNode("ul", _hoisted_116, [
                                        _createElementVNode("li", _hoisted_117, [
                                          _cache[47] || (_cache[47] = _createElementVNode("span", { class: "text-secondary" }, "Target Index", -1)),
                                          _createElementVNode("span", _hoisted_118, _toDisplayString(_ctx.order.all_detail.target_index), 1)
                                        ]),
                                        _createElementVNode("li", _hoisted_119, [
                                          _cache[48] || (_cache[48] = _createElementVNode("span", { class: "text-secondary" }, "Field of Study", -1)),
                                          _createElementVNode("span", _hoisted_120, _toDisplayString(_ctx.order.all_detail.field_of_study), 1)
                                        ]),
                                        (_ctx.order.all_detail.page_count)
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_121, [
                                              _cache[49] || (_cache[49] = _createElementVNode("span", { class: "text-secondary" }, "Page Count", -1)),
                                              _createElementVNode("span", _hoisted_122, _toDisplayString(_ctx.order.all_detail.page_count), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.order.all_detail.price_tier)
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_123, [
                                              _cache[50] || (_cache[50] = _createElementVNode("span", { class: "text-secondary" }, "Price Tier", -1)),
                                              _createElementVNode("span", _hoisted_124, [
                                                _createTextVNode(_toDisplayString(_ctx.order.all_detail.price_tier.label) + " ", 1),
                                                (_ctx.order.all_detail.price_tier.deadline)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_125, _toDisplayString(_ctx.order.all_detail.price_tier.deadline), 1))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                    (_ctx.order.processed_by)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                          _createElementVNode("ul", _hoisted_127, [
                            _createElementVNode("li", _hoisted_128, [
                              _cache[55] || (_cache[55] = _createElementVNode("span", { class: "text-secondary" }, "Last Processed By", -1)),
                              _createElementVNode("span", _hoisted_129, [
                                _createTextVNode(_toDisplayString(_ctx.order.processed_by.name) + " ", 1),
                                _createElementVNode("small", _hoisted_130, "(" + _toDisplayString(_ctx.order.processed_by.email) + ")", 1)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_131, [
                  _cache[64] || (_cache[64] = _createElementVNode("div", { class: "card-header bg-light-subtle d-flex align-items-center gap-2 py-3 px-4" }, [
                    _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-22" }, "tune"),
                    _createElementVNode("h5", { class: "mb-0 fs-15 fw-bold text-dark" }, "Pilihan Klasifikasi Dokumen & Status")
                  ], -1)),
                  _createElementVNode("div", _hoisted_132, [
                    _createElementVNode("div", _hoisted_133, [
                      _createElementVNode("div", _hoisted_134, [
                        _cache[59] || (_cache[59] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold text-secondary mb-1" }, " Klasifikasi / Preset Similarity Profile: ", -1)),
                        _createElementVNode("div", _hoisted_135, [
                          _cache[58] || (_cache[58] = _createElementVNode("span", { class: "input-group-text bg-light text-primary" }, [
                            _createElementVNode("span", { class: "material-symbols-outlined fs-18" }, "category")
                          ], -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select form-select-sm",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.profileUpdate) = $event)),
                            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateProfile && _ctx.updateProfile(...args))),
                            disabled: _ctx.updatingProfile
                          }, [
                            _cache[57] || (_cache[57] = _createElementVNode("option", { value: null }, "-- Custom / Bebas --", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.similarityProfiles, (p) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: p.id,
                                value: p.id
                              }, _toDisplayString(p.service_classification) + " (" + _toDisplayString(p.profile_name) + ") ", 9, _hoisted_137))
                            }), 128))
                          ], 40, _hoisted_136), [
                            [_vModelSelect, _ctx.profileUpdate]
                          ])
                        ]),
                        (_ctx.selectedProfileInfo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                              _createElementVNode("span", _hoisted_139, " Maks. Total: " + _toDisplayString(_ctx.selectedProfileInfo.default_max_overall) + "% ", 1),
                              _createElementVNode("span", _hoisted_140, " Maks. Tunggal: " + _toDisplayString(_ctx.selectedProfileInfo.default_max_single_source) + "% ", 1),
                              (_ctx.selectedProfileInfo.exclude_bibliography)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_141, " Excl. Biblio "))
                                : _createCommentVNode("", true),
                              (_ctx.selectedProfileInfo.exclude_quotes)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_142, " Excl. Quotes "))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_143, [
                        _cache[63] || (_cache[63] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold text-secondary mb-1" }, " Status Pesanan: ", -1)),
                        _createElementVNode("div", _hoisted_144, [
                          _cache[61] || (_cache[61] = _createElementVNode("span", { class: "input-group-text bg-light text-secondary" }, [
                            _createElementVNode("span", { class: "material-symbols-outlined fs-18" }, "sync_alt")
                          ], -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select form-select-sm",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.statusUpdate) = $event)),
                            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateStatus && _ctx.updateStatus(...args)))
                          }, _cache[60] || (_cache[60] = [
                            _createElementVNode("option", { value: "Pending" }, "Pending", -1),
                            _createElementVNode("option", { value: "Processing" }, "Processing", -1),
                            _createElementVNode("option", { value: "Completed" }, "Completed", -1),
                            _createElementVNode("option", { value: "Cancelled" }, "Cancelled", -1)
                          ]), 544), [
                            [_vModelSelect, _ctx.statusUpdate]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_145, [
                          _cache[62] || (_cache[62] = _createTextVNode(" Status saat ini: ")),
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge p-1 px-2 fs-11 fw-normal", _ctx.statusClass(_ctx.order.order_status)])
                          }, _toDisplayString(_ctx.order.order_status), 3)
                        ])
                      ])
                    ])
                  ])
                ]),
                (_ctx.requiredProtocols.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                      _createElementVNode("div", _hoisted_147, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_148, _toDisplayString(_ctx.order.package ? `Paket: ${_ctx.order.package.package_name}` : 'Paket Layanan') + " - Pilih Protokol SOP: ", 1),
                          _createElementVNode("small", _hoisted_149, "Paket ini memuat " + _toDisplayString(_ctx.requiredProtocols.length) + " sertifikasi protokol resmi yang perlu diproses.", 1)
                        ]),
                        _createElementVNode("div", _hoisted_150, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requiredProtocols, (proto) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: proto.key,
                              type: "button",
                              class: _normalizeClass(["btn btn-sm", _ctx.activeProtocolTab === proto.key ? 'btn-primary' : 'btn-outline-primary']),
                              onClick: ($event: any) => (_ctx.activeProtocolTab = proto.key)
                            }, _toDisplayString(proto.label), 11, _hoisted_151))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.requiredProtocols.some(p => p.key === 'SIM') && (_ctx.requiredProtocols.length === 1 || _ctx.activeProtocolTab === 'SIM'))
                  ? (_openBlock(), _createBlock(_component_SimilarityProtocolForm, {
                      key: 1,
                      order: _ctx.order,
                      onRefresh: _cache[4] || (_cache[4] = () => _ctx.fetchOrder(_ctx.order.order_id))
                    }, null, 8, ["order"]))
                  : _createCommentVNode("", true),
                (_ctx.requiredProtocols.some(p => p.key === 'GRM') && (_ctx.requiredProtocols.length === 1 || _ctx.activeProtocolTab === 'GRM'))
                  ? (_openBlock(), _createBlock(_component_GrammarlyProtocolForm, {
                      key: 2,
                      order: _ctx.order,
                      onRefresh: _cache[5] || (_cache[5] = () => _ctx.fetchOrder(_ctx.order.order_id))
                    }, null, 8, ["order"]))
                  : _createCommentVNode("", true),
                (_ctx.requiredProtocols.some(p => p.key === 'AI') && (_ctx.requiredProtocols.length === 1 || _ctx.activeProtocolTab === 'AI'))
                  ? (_openBlock(), _createBlock(_component_AiDetectorProtocolForm, {
                      key: 3,
                      order: _ctx.order,
                      onRefresh: _cache[6] || (_cache[6] = () => _ctx.fetchOrder(_ctx.order.order_id))
                    }, null, 8, ["order"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_OrderDeliverablesAndQc, {
                  order: _ctx.order,
                  onRefresh: _cache[7] || (_cache[7] = () => _ctx.fetchOrder(_ctx.order.order_id))
                }, null, 8, ["order"]),
                (_ctx.previewFiles.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                      _createElementVNode("div", _hoisted_153, [
                        _createElementVNode("div", _hoisted_154, [
                          _cache[65] || (_cache[65] = _createElementVNode("h4", { class: "fs-15 mb-0 pb-1" }, "Document Preview", -1)),
                          (_ctx.previewFiles.length > 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previewFiles, (file, idx) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    key: idx,
                                    class: _normalizeClass(["btn btn-sm py-1 px-2 fs-12 fw-medium border-0", _ctx.activePreviewIdx === idx ? 'btn-primary text-white' : 'btn-light text-secondary']),
                                    onClick: ($event: any) => (_ctx.activePreviewIdx = idx)
                                  }, _toDisplayString(file.label), 11, _hoisted_156))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previewFiles, (file, idx) => {
                          return _withDirectives((_openBlock(), _createElementBlock("div", { key: idx }, [
                            (file.type === 'pdf')
                              ? (_openBlock(), _createElementBlock("iframe", {
                                  key: 0,
                                  src: file.url,
                                  width: "100%",
                                  height: "600px",
                                  style: {"border":"1px solid #eee","border-radius":"8px"}
                                }, null, 8, _hoisted_157))
                              : (file.type === 'docx')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_158, [
                                    _createVNode(_component_vue_office_docx, {
                                      src: file.url,
                                      style: {"height":"100%"}
                                    }, null, 8, ["src"])
                                  ]))
                                : _createCommentVNode("", true)
                          ])), [
                            [_vShow, _ctx.activePreviewIdx === idx]
                          ])
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_159, [
                _createElementVNode("div", _hoisted_160, [
                  _createElementVNode("div", _hoisted_161, [
                    _cache[113] || (_cache[113] = _createElementVNode("h3", { class: "mb-4" }, "Attachments & Files", -1)),
                    (_ctx.order.service_type === 'AI_CHECK' && _ctx.order.ai_check_detail)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_162, [
                            _cache[67] || (_cache[67] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><i class=\"ri-file-word-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-primary rounded-circle\"></i></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"mb-1 fs-14 fw-medium text-truncate\" style=\"max-width:180px;\">Source File</h4><span class=\"fs-13 text-secondary\">Document</span></div></div>", 1)),
                            (_ctx.order.ai_check_detail.source_file)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: _ctx.getFileUrl(_ctx.order.ai_check_detail.source_file),
                                  target: _ctx.isPdf(_ctx.order.ai_check_detail.source_file) ? '_blank' : null,
                                  download: !_ctx.isPdf(_ctx.order.ai_check_detail.source_file),
                                  class: "p-0 border-0 bg-transparent"
                                }, _cache[66] || (_cache[66] = [
                                  _createElementVNode("i", { class: "ri-download-2-line fs-22 text-primary" }, null, -1)
                                ]), 8, _hoisted_163))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.order.ai_check_detail.result_report_file)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
                                _cache[69] || (_cache[69] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><i class=\"ri-file-pdf-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-success rounded-circle\"></i></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"mb-1 fs-14 fw-medium text-truncate\" style=\"max-width:180px;\">Result Report</h4><span class=\"fs-13 text-secondary\">Document</span></div></div>", 1)),
                                _createElementVNode("a", {
                                  href: _ctx.getFileUrl(_ctx.order.ai_check_detail.result_report_file),
                                  target: _ctx.isPdf(_ctx.order.ai_check_detail.result_report_file) ? '_blank' : null,
                                  download: !_ctx.isPdf(_ctx.order.ai_check_detail.result_report_file),
                                  class: "p-0 border-0 bg-transparent"
                                }, _cache[68] || (_cache[68] = [
                                  _createElementVNode("i", { class: "ri-download-2-line fs-22 text-primary" }, null, -1)
                                ]), 8, _hoisted_165)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.order.ai_check_detail.ai_score)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                                _createElementVNode("div", _hoisted_167, [
                                  _cache[71] || (_cache[71] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                                    _createElementVNode("i", { class: "ri-percent-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-warning rounded-circle" })
                                  ], -1)),
                                  _createElementVNode("div", _hoisted_168, [
                                    _cache[70] || (_cache[70] = _createElementVNode("h4", {
                                      class: "mb-1 fs-14 fw-medium text-truncate",
                                      style: {"max-width":"180px"}
                                    }, "AI Score", -1)),
                                    _createElementVNode("span", _hoisted_169, _toDisplayString(_ctx.order.ai_check_detail.ai_score), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.order.service_type === 'PLAGIARISM' && _ctx.order.plagiarism_detail)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_170, [
                            _cache[73] || (_cache[73] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><i class=\"ri-file-word-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-primary rounded-circle\"></i></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"mb-1 fs-14 fw-medium text-truncate\" style=\"max-width:180px;\">Source File</h4><span class=\"fs-13 text-secondary\">Document</span></div></div>", 1)),
                            (_ctx.order.plagiarism_detail.source_file)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: _ctx.getFileUrl(_ctx.order.plagiarism_detail.source_file),
                                  target: _ctx.isPdf(_ctx.order.plagiarism_detail.source_file) ? '_blank' : null,
                                  download: !_ctx.isPdf(_ctx.order.plagiarism_detail.source_file),
                                  class: "p-0 border-0 bg-transparent"
                                }, _cache[72] || (_cache[72] = [
                                  _createElementVNode("i", { class: "ri-download-2-line fs-22 text-primary" }, null, -1)
                                ]), 8, _hoisted_171))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.order.plagiarism_detail.result_report_file)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_172, [
                                _cache[75] || (_cache[75] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><i class=\"ri-file-pdf-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-success rounded-circle\"></i></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"mb-1 fs-14 fw-medium text-truncate\" style=\"max-width:180px;\">Result Report</h4><span class=\"fs-13 text-secondary\">Document</span></div></div>", 1)),
                                _createElementVNode("a", {
                                  href: _ctx.getFileUrl(_ctx.order.plagiarism_detail.result_report_file),
                                  target: _ctx.isPdf(_ctx.order.plagiarism_detail.result_report_file) ? '_blank' : null,
                                  download: !_ctx.isPdf(_ctx.order.plagiarism_detail.result_report_file),
                                  class: "p-0 border-0 bg-transparent"
                                }, _cache[74] || (_cache[74] = [
                                  _createElementVNode("i", { class: "ri-download-2-line fs-22 text-primary" }, null, -1)
                                ]), 8, _hoisted_173)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.order.plagiarism_detail.plagiarism_ai_score)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                                _createElementVNode("div", _hoisted_175, [
                                  _cache[77] || (_cache[77] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                                    _createElementVNode("i", { class: "ri-percent-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-warning rounded-circle" })
                                  ], -1)),
                                  _createElementVNode("div", _hoisted_176, [
                                    _cache[76] || (_cache[76] = _createElementVNode("h4", {
                                      class: "mb-1 fs-14 fw-medium text-truncate",
                                      style: {"max-width":"180px"}
                                    }, "Plagiarism Score", -1)),
                                    _createElementVNode("span", _hoisted_177, _toDisplayString(_ctx.order.plagiarism_detail.plagiarism_ai_score), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.order.service_type === 'PARAPHRASE' && _ctx.order.paraphrase_detail)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("div", _hoisted_178, [
                            _cache[79] || (_cache[79] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><i class=\"ri-file-word-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-primary rounded-circle\"></i></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"mb-1 fs-14 fw-medium text-truncate\" style=\"max-width:180px;\">Source File</h4><span class=\"fs-13 text-secondary\">Document</span></div></div>", 1)),
                            (_ctx.order.paraphrase_detail.source_file)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: _ctx.getFileUrl(_ctx.order.paraphrase_detail.source_file),
                                  target: _ctx.isPdf(_ctx.order.paraphrase_detail.source_file) ? '_blank' : null,
                                  download: !_ctx.isPdf(_ctx.order.paraphrase_detail.source_file),
                                  class: "p-0 border-0 bg-transparent"
                                }, _cache[78] || (_cache[78] = [
                                  _createElementVNode("i", { class: "ri-download-2-line fs-22 text-primary" }, null, -1)
                                ]), 8, _hoisted_179))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.order.paraphrase_detail.result_file)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                                _cache[81] || (_cache[81] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><i class=\"ri-file-word-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-success rounded-circle\"></i></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"mb-1 fs-14 fw-medium text-truncate\" style=\"max-width:180px;\">Completed File</h4><span class=\"fs-13 text-secondary\">Document</span></div></div>", 1)),
                                _createElementVNode("a", {
                                  href: _ctx.getFileUrl(_ctx.order.paraphrase_detail.result_file),
                                  target: _ctx.isPdf(_ctx.order.paraphrase_detail.result_file) ? '_blank' : null,
                                  download: !_ctx.isPdf(_ctx.order.paraphrase_detail.result_file),
                                  class: "p-0 border-0 bg-transparent"
                                }, _cache[80] || (_cache[80] = [
                                  _createElementVNode("i", { class: "ri-download-2-line fs-22 text-primary" }, null, -1)
                                ]), 8, _hoisted_181)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.order.service_type === 'DOC_FIX' && _ctx.order.document_fix_detail)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createElementVNode("div", _hoisted_182, [
                            _cache[83] || (_cache[83] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><i class=\"ri-file-word-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-primary rounded-circle\"></i></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"mb-1 fs-14 fw-medium text-truncate\" style=\"max-width:180px;\">Raw File</h4><span class=\"fs-13 text-secondary\">Document</span></div></div>", 1)),
                            (_ctx.order.document_fix_detail.raw_file)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: _ctx.getFileUrl(_ctx.order.document_fix_detail.raw_file),
                                  target: _ctx.isPdf(_ctx.order.document_fix_detail.raw_file) ? '_blank' : null,
                                  download: !_ctx.isPdf(_ctx.order.document_fix_detail.raw_file),
                                  class: "p-0 border-0 bg-transparent"
                                }, _cache[82] || (_cache[82] = [
                                  _createElementVNode("i", { class: "ri-download-2-line fs-22 text-primary" }, null, -1)
                                ]), 8, _hoisted_183))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.order.document_fix_detail.guideline_file)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                                _cache[85] || (_cache[85] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><i class=\"ri-file-pdf-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-danger rounded-circle\"></i></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"mb-1 fs-14 fw-medium text-truncate\" style=\"max-width:180px;\">Guidelines</h4><span class=\"fs-13 text-secondary\">Reference</span></div></div>", 1)),
                                _createElementVNode("a", {
                                  href: _ctx.getFileUrl(_ctx.order.document_fix_detail.guideline_file),
                                  target: _ctx.isPdf(_ctx.order.document_fix_detail.guideline_file) ? '_blank' : null,
                                  download: !_ctx.isPdf(_ctx.order.document_fix_detail.guideline_file),
                                  class: "p-0 border-0 bg-transparent"
                                }, _cache[84] || (_cache[84] = [
                                  _createElementVNode("i", { class: "ri-download-2-line fs-22 text-primary" }, null, -1)
                                ]), 8, _hoisted_185)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.order.document_fix_detail.final_file)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                                _cache[87] || (_cache[87] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><i class=\"ri-file-word-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-success rounded-circle\"></i></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"mb-1 fs-14 fw-medium text-truncate\" style=\"max-width:180px;\">Fixed Document</h4><span class=\"fs-13 text-secondary\">Document</span></div></div>", 1)),
                                _createElementVNode("a", {
                                  href: _ctx.getFileUrl(_ctx.order.document_fix_detail.final_file),
                                  target: _ctx.isPdf(_ctx.order.document_fix_detail.final_file) ? '_blank' : null,
                                  download: !_ctx.isPdf(_ctx.order.document_fix_detail.final_file),
                                  class: "p-0 border-0 bg-transparent"
                                }, _cache[86] || (_cache[86] = [
                                  _createElementVNode("i", { class: "ri-download-2-line fs-22 text-primary" }, null, -1)
                                ]), 8, _hoisted_187)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.order.service_type === 'JOURNAL' && _ctx.order.journal_detail)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          _createElementVNode("div", _hoisted_188, [
                            _cache[89] || (_cache[89] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><i class=\"ri-file-pdf-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-danger rounded-circle\"></i></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"mb-1 fs-14 fw-medium text-truncate\" style=\"max-width:180px;\">Manuscript</h4><span class=\"fs-13 text-secondary\">Document</span></div></div>", 1)),
                            (_ctx.order.journal_detail.manuscript_file)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: _ctx.getFileUrl(_ctx.order.journal_detail.manuscript_file),
                                  target: _ctx.isPdf(_ctx.order.journal_detail.manuscript_file) ? '_blank' : null,
                                  download: !_ctx.isPdf(_ctx.order.journal_detail.manuscript_file),
                                  class: "p-0 border-0 bg-transparent"
                                }, _cache[88] || (_cache[88] = [
                                  _createElementVNode("i", { class: "ri-download-2-line fs-22 text-primary" }, null, -1)
                                ]), 8, _hoisted_189))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.order.journal_detail.loi_certificate_file)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
                                _cache[91] || (_cache[91] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><i class=\"ri-file-pdf-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-success rounded-circle\"></i></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"mb-1 fs-14 fw-medium text-truncate\" style=\"max-width:180px;\">LOI / Certificate</h4><span class=\"fs-13 text-secondary\">Document</span></div></div>", 1)),
                                _createElementVNode("a", {
                                  href: _ctx.getFileUrl(_ctx.order.journal_detail.loi_certificate_file),
                                  target: _ctx.isPdf(_ctx.order.journal_detail.loi_certificate_file) ? '_blank' : null,
                                  download: !_ctx.isPdf(_ctx.order.journal_detail.loi_certificate_file),
                                  class: "p-0 border-0 bg-transparent"
                                }, _cache[90] || (_cache[90] = [
                                  _createElementVNode("i", { class: "ri-download-2-line fs-22 text-primary" }, null, -1)
                                ]), 8, _hoisted_191)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.order.service_type === 'TRANSLATE' && _ctx.order.translate_detail)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                          _createElementVNode("div", _hoisted_192, [
                            _cache[93] || (_cache[93] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><i class=\"ri-file-word-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-primary rounded-circle\"></i></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"mb-1 fs-14 fw-medium text-truncate\" style=\"max-width:180px;\">Source File</h4><span class=\"fs-13 text-secondary\">Document</span></div></div>", 1)),
                            (_ctx.order.translate_detail.manuscript_file)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: _ctx.getFileUrl(_ctx.order.translate_detail.manuscript_file),
                                  target: _ctx.isPdf(_ctx.order.translate_detail.manuscript_file) ? '_blank' : null,
                                  download: !_ctx.isPdf(_ctx.order.translate_detail.manuscript_file),
                                  class: "p-0 border-0 bg-transparent"
                                }, _cache[92] || (_cache[92] = [
                                  _createElementVNode("i", { class: "ri-download-2-line fs-22 text-primary" }, null, -1)
                                ]), 8, _hoisted_193))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.order.translate_detail.result_file)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_194, [
                                _cache[95] || (_cache[95] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><i class=\"ri-file-word-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-success rounded-circle\"></i></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"mb-1 fs-14 fw-medium text-truncate\" style=\"max-width:180px;\">Translated File</h4><span class=\"fs-13 text-secondary\">Document</span></div></div>", 1)),
                                _createElementVNode("a", {
                                  href: _ctx.getFileUrl(_ctx.order.translate_detail.result_file),
                                  target: _ctx.isPdf(_ctx.order.translate_detail.result_file) ? '_blank' : null,
                                  download: !_ctx.isPdf(_ctx.order.translate_detail.result_file),
                                  class: "p-0 border-0 bg-transparent"
                                }, _cache[94] || (_cache[94] = [
                                  _createElementVNode("i", { class: "ri-download-2-line fs-22 text-primary" }, null, -1)
                                ]), 8, _hoisted_195)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.order.service_type === 'ALL' && _ctx.order.all_detail)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                          _createElementVNode("div", _hoisted_196, [
                            _cache[97] || (_cache[97] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><i class=\"ri-file-word-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-primary rounded-circle\"></i></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"mb-1 fs-14 fw-medium text-truncate\" style=\"max-width:180px;\">Source File</h4><span class=\"fs-13 text-secondary\">Document</span></div></div>", 1)),
                            (_ctx.order.all_detail.source_file)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: _ctx.getFileUrl(_ctx.order.all_detail.source_file),
                                  target: _ctx.isPdf(_ctx.order.all_detail.source_file) ? '_blank' : null,
                                  download: !_ctx.isPdf(_ctx.order.all_detail.source_file),
                                  class: "p-0 border-0 bg-transparent"
                                }, _cache[96] || (_cache[96] = [
                                  _createElementVNode("i", { class: "ri-download-2-line fs-22 text-primary" }, null, -1)
                                ]), 8, _hoisted_197))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.order.all_detail.result_report_file)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                                _cache[99] || (_cache[99] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><i class=\"ri-file-pdf-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-success rounded-circle\"></i></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"mb-1 fs-14 fw-medium text-truncate\" style=\"max-width:180px;\">Result Report</h4><span class=\"fs-13 text-secondary\">Plagiarism Report</span></div></div>", 1)),
                                _createElementVNode("a", {
                                  href: _ctx.getFileUrl(_ctx.order.all_detail.result_report_file),
                                  target: _ctx.isPdf(_ctx.order.all_detail.result_report_file) ? '_blank' : null,
                                  download: !_ctx.isPdf(_ctx.order.all_detail.result_report_file),
                                  class: "p-0 border-0 bg-transparent"
                                }, _cache[98] || (_cache[98] = [
                                  _createElementVNode("i", { class: "ri-download-2-line fs-22 text-primary" }, null, -1)
                                ]), 8, _hoisted_199)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.order.all_detail.plagiarism_ai_score)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_200, [
                                _createElementVNode("div", _hoisted_201, [
                                  _cache[101] || (_cache[101] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                                    _createElementVNode("i", { class: "ri-percent-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-warning rounded-circle" })
                                  ], -1)),
                                  _createElementVNode("div", _hoisted_202, [
                                    _cache[100] || (_cache[100] = _createElementVNode("h4", {
                                      class: "mb-1 fs-14 fw-medium text-truncate",
                                      style: {"max-width":"180px"}
                                    }, "Plagiarism Score", -1)),
                                    _createElementVNode("span", _hoisted_203, _toDisplayString(_ctx.order.all_detail.plagiarism_ai_score), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.order.all_detail.result_file_paraphrase)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_204, [
                                _cache[103] || (_cache[103] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><i class=\"ri-file-word-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-success rounded-circle\"></i></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"mb-1 fs-14 fw-medium text-truncate\" style=\"max-width:180px;\">Completed File</h4><span class=\"fs-13 text-secondary\">Paraphrase Result</span></div></div>", 1)),
                                _createElementVNode("a", {
                                  href: _ctx.getFileUrl(_ctx.order.all_detail.result_file_paraphrase),
                                  target: _ctx.isPdf(_ctx.order.all_detail.result_file_paraphrase) ? '_blank' : null,
                                  download: !_ctx.isPdf(_ctx.order.all_detail.result_file_paraphrase),
                                  class: "p-0 border-0 bg-transparent"
                                }, _cache[102] || (_cache[102] = [
                                  _createElementVNode("i", { class: "ri-download-2-line fs-22 text-primary" }, null, -1)
                                ]), 8, _hoisted_205)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.order.all_detail.guideline_file)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_206, [
                                _cache[105] || (_cache[105] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><i class=\"ri-file-pdf-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-danger rounded-circle\"></i></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"mb-1 fs-14 fw-medium text-truncate\" style=\"max-width:180px;\">Guidelines</h4><span class=\"fs-13 text-secondary\">Doc Fix Guideline</span></div></div>", 1)),
                                _createElementVNode("a", {
                                  href: _ctx.getFileUrl(_ctx.order.all_detail.guideline_file),
                                  target: _ctx.isPdf(_ctx.order.all_detail.guideline_file) ? '_blank' : null,
                                  download: !_ctx.isPdf(_ctx.order.all_detail.guideline_file),
                                  class: "p-0 border-0 bg-transparent"
                                }, _cache[104] || (_cache[104] = [
                                  _createElementVNode("i", { class: "ri-download-2-line fs-22 text-primary" }, null, -1)
                                ]), 8, _hoisted_207)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.order.all_detail.final_file_doc_fix)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_208, [
                                _cache[107] || (_cache[107] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><i class=\"ri-file-word-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-success rounded-circle\"></i></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"mb-1 fs-14 fw-medium text-truncate\" style=\"max-width:180px;\">Fixed Document</h4><span class=\"fs-13 text-secondary\">Doc Fix Result</span></div></div>", 1)),
                                _createElementVNode("a", {
                                  href: _ctx.getFileUrl(_ctx.order.all_detail.final_file_doc_fix),
                                  target: _ctx.isPdf(_ctx.order.all_detail.final_file_doc_fix) ? '_blank' : null,
                                  download: !_ctx.isPdf(_ctx.order.all_detail.final_file_doc_fix),
                                  class: "p-0 border-0 bg-transparent"
                                }, _cache[106] || (_cache[106] = [
                                  _createElementVNode("i", { class: "ri-download-2-line fs-22 text-primary" }, null, -1)
                                ]), 8, _hoisted_209)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.order.all_detail.loi_certificate_file)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_210, [
                                _cache[109] || (_cache[109] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><i class=\"ri-file-pdf-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-success rounded-circle\"></i></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"mb-1 fs-14 fw-medium text-truncate\" style=\"max-width:180px;\">LOI / Certificate</h4><span class=\"fs-13 text-secondary\">Journal LOI</span></div></div>", 1)),
                                _createElementVNode("a", {
                                  href: _ctx.getFileUrl(_ctx.order.all_detail.loi_certificate_file),
                                  target: _ctx.isPdf(_ctx.order.all_detail.loi_certificate_file) ? '_blank' : null,
                                  download: !_ctx.isPdf(_ctx.order.all_detail.loi_certificate_file),
                                  class: "p-0 border-0 bg-transparent"
                                }, _cache[108] || (_cache[108] = [
                                  _createElementVNode("i", { class: "ri-download-2-line fs-22 text-primary" }, null, -1)
                                ]), 8, _hoisted_211)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    _cache[114] || (_cache[114] = _createElementVNode("hr", { class: "my-4" }, null, -1)),
                    _cache[115] || (_cache[115] = _createElementVNode("h4", { class: "fs-14 fw-medium mb-3" }, "Upload Admin Result", -1)),
                    _cache[116] || (_cache[116] = _createElementVNode("div", { class: "alert alert-info py-2 fs-13 mb-3" }, " Upload final results/reports to deliver to the customer. ", -1)),
                    _createElementVNode("form", {
                      onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.uploadAdminResult && _ctx.uploadAdminResult(...args)), ["prevent"]))
                    }, [
                      (_ctx.order.service_type === 'ALL')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_212, [
                            _cache[111] || (_cache[111] = _createElementVNode("label", { class: "form-label fs-13 text-dark fw-medium" }, "Upload File Target", -1)),
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select form-select-sm",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.allResultType) = $event))
                            }, _cache[110] || (_cache[110] = [
                              _createElementVNode("option", { value: "plagiarism" }, "Plagiarism Report & Score", -1),
                              _createElementVNode("option", { value: "paraphrase" }, "Paraphrase Result File", -1),
                              _createElementVNode("option", { value: "doc_fix" }, "Fixed Document File", -1),
                              _createElementVNode("option", { value: "journal" }, "LOI / Certificate File", -1)
                            ]), 512), [
                              [_vModelSelect, _ctx.allResultType]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.order.service_type === 'PLAGIARISM' || _ctx.order.service_type === 'AI_CHECK' || (_ctx.order.service_type === 'ALL' && _ctx.allResultType === 'plagiarism'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_213, [
                            _createElementVNode("label", _hoisted_214, _toDisplayString(_ctx.order.service_type === 'AI_CHECK' ? 'AI Score' : 'Plagiarism Score') + " (e.g., 8%)", 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-sm",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.plagiarismScore) = $event)),
                              placeholder: _ctx.order.service_type === 'AI_CHECK' ? 'AI Score' : 'Score'
                            }, null, 8, _hoisted_215), [
                              [_vModelText, _ctx.plagiarismScore]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_216, [
                        _createElementVNode("input", {
                          class: "form-control form-control-sm",
                          type: "file",
                          id: "resultFile",
                          onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
                          accept: ".pdf,.doc,.docx,.zip,.rar"
                        }, null, 32)
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-primary btn-sm w-100",
                        disabled: _ctx.uploadingResult
                      }, [
                        (_ctx.uploadingResult)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_218))
                          : _createCommentVNode("", true),
                        _cache[112] || (_cache[112] = _createTextVNode(" Upload Result "))
                      ], 8, _hoisted_217)
                    ], 32)
                  ])
                ])
              ])
            ])
          ]))
  ]))
}